import {h} from 'preact';
import {useCalculatorContext} from '../context';
import {actions} from '../reducer';
import {CalculatorOption, CalculatorProduct} from '../types';
import {CounterWidget} from './CounterWidget';
import {TableRow} from './TableRow';
import {ToggleWidget} from './ToggleWidget';

type OptionProps = {
  item: CalculatorOption;
  id: number;
}

function Option({item, id}: OptionProps) {
  const {
    name,
    prefix, 
    subscription, 
    type,
    initial,
    qty,
  } = item;
  const { state: {serviceKits, currentKitIndex}, dispatch} = useCalculatorContext();
  const count = qty 
    ? qty 
    : initial 
    ? initial 
    : 0;

  function incrementQty(option: CalculatorOption) {
    const maxVal: number = option.max > 0 ? option.max : Infinity;
    if (option.initial > maxVal)  return;
    const qty = (option?.qty > 0) ? option.qty : option.initial ? option.initial : 0;
    dispatch(actions.setProductsQty({ productType: "option", productId: id, qty: qty + 1}))
    dispatch(
      actions.setOptionsSum(serviceKits[currentKitIndex].subscription_min)
    )
  }
  function decrementQty(option: CalculatorOption) {
    const minVal: number = option.min ? option.min : 0;
    if (option?.qty <= minVal)  return;
    const qty = (option?.qty > 0) ? option.qty : option.initial ? option.initial : 0;
    dispatch(actions.setProductsQty({productType: "option", productId: id, qty: qty - 1}))
    dispatch(
      actions.setOptionsSum(serviceKits[currentKitIndex].subscription_min)
    )
  }

  function updateAmount(product: CalculatorOption) {
    return (amountArg: number) => {
      const amount = +amountArg;
      const minVal: number = product.min ? product.min : 0;
      const maxVal: number = product.max > 0 ? product.max : Infinity;
      if (product.initial < minVal || product.initial > maxVal)  return;
      dispatch(actions.setProductsQty({productId: id, qty: amount, productType: "option"}))
      dispatch(
        actions.setOptionsSum(serviceKits[currentKitIndex].subscription_min)
      )
    }
  }
  return (
    <>
        <TableRow>
          <div className="kits__table-row-item product-name wide name">{name}</div>
          <div className="kits__table-row-item subscription-price right ">
            <span>{prefix && prefix}</span> {subscription} руб./ месяц
          </div>

          { (type === 'toggle'
            ) ? (
              <ToggleWidget 
                value={count as unknown as boolean}
                incrementQty={() => incrementQty(item)}
                decrementQty={() => decrementQty(item)} 
              /> 
            ) : (
              <CounterWidget 
                value={count} 
                incrementQty={() => incrementQty(item)} 
                decrementQty={() => decrementQty(item)} 
                updateAmount={updateAmount(item)}
              />
            )
          }
        </TableRow>
    </>
  )
}

export {Option};

